import { RECENTLY_USED_PREFIX, DISABLE_LABEL_LOWERCASING_ASSET_TYPES } from '../constants/campaignSelect';
import { USER_ATTRIBUTE_KEYS } from '../constants/userAttributes';
import { setSuperStoreValue } from '../api/superstore';
import I18n from 'I18n';
export const sanitizeValue = (value = '') => value.replace(RECENTLY_USED_PREFIX, '');
export const hasAlreadyCampaignAssociated = value => {
  return Boolean(typeof value === 'string' && value) || Array.isArray(value) && value.length > 0;
};
export function toCampaignOption({
  colorHex,
  createdAt,
  createdBy,
  display_name,
  guid,
  utm,
  objectId
}) {
  return {
    colorHex,
    createdAt,
    createdBy,
    display_name,
    guid: guid || '',
    text: display_name,
    utm,
    value: guid || '',
    objectId
  };
}
export function setCampaignToAutoSelect(campaignGuid) {
  return setSuperStoreValue(USER_ATTRIBUTE_KEYS.CAMPAIGN_TO_AUTO_SELECT, campaignGuid);
}

/**
 * Formats an asset label based on the asset object type.
 * Some asset types should not have their labels lowercased.
 *
 * @param assetObjectType - The type of asset (e.g., 'CTA', 'MARKETING_EMAIL')
 * @param assetLabel - The label to format (optional, will use default if not provided)
 * @returns The formatted label (lowercased or not based on asset type)
 */
export function formatAssetLabel(assetObjectType, assetLabel) {
  const shouldDisableLowerCasing = assetObjectType ? DISABLE_LABEL_LOWERCASING_ASSET_TYPES.includes(assetObjectType) : false;
  const label = assetLabel || I18n.text('campaignSelect.defaultAssetLabel');
  return shouldDisableLowerCasing ? label : label.toLowerCase();
}